<template>
<span
  :title="bindings.tooltip"
  v-if="bindings"
>
  <ItpIcon
    :name="bindings.icon"
    :color="bindings.color"
  >
  </ItpIcon>
</span>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcPaymentTransactionTypeSymbol extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  transactionType!: string;

  @Watch('transactionType')
  onTransaction_type(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("transactionType")
  }

  transactionTypes!: any;
  ux!: any;
  dataMembers = ['transactionTypes', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        transactionTypes: {
          credit: {
            icon: "mdi:plus-box",
            tooltip: this.$fn.pgettext("PaymentType", "credit"),
            color: "green",
          }
          ,
          debit: {
            icon: "mdi:minus-box",
            tooltip: this.$fn.pgettext("PaymentType", "debit"),
            color: "red",
          }
          ,
          deposit: {
            icon: "mdi:plus-box",
            tooltip: this.$fn.pgettext("PaymentType", "deposit"),
            color: "green",
          }
          ,
          payment: {
            icon: "mdi:minus-box",
            tooltip: this.$fn.pgettext("PaymentType", "payment"),
            color: "red",
          }
          ,
          invoice_reconciliation: {
            icon: "material-symbols:compare-arrows",
            color: "blue",
          }
          ,
          write_off: {
            icon: "material-symbols:arrow-right-alt",
            color: "blue",
          }
          ,
        }
        ,
        ux: null,
      },
    }
  }

  get bindings() {
    if (this.loaded) {

      return this.transactionTypes[this.transactionType || 'default']
    }
    return null;
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcPaymentTransactionTypeSymbol", UcPaymentTransactionTypeSymbol);

</script>